import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';

export interface RepaidLoanActionsButtonProps {
    loan: IBridgeLoanGridRecord;
}

// TODO: Actions placeholder
export const RepaidLoanActionsButton = ({ loan }: RepaidLoanActionsButtonProps) => (
    <Button
        id={`action_bridge_repaid_loans_${loan.id}`}
        hint='Click to see options'
        handleClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            alert('Actions Menu Click in Development');
        }}
        theme={ButtonTheme.GridGrey}
        borderRadius={ButtonBorderRadius.Small}
        height='20px'
        width='24px'
    >
        <FontAwesomeIcon icon={faEllipsis} />
    </Button>
);
